import { render, staticRenderFns } from "./StudyTaskRecommend.vue?vue&type=template&id=0a1ced72&scoped=true&"
import script from "./StudyTaskRecommend.vue?vue&type=script&lang=js&"
export * from "./StudyTaskRecommend.vue?vue&type=script&lang=js&"
import style0 from "./StudyTaskRecommend.vue?vue&type=style&index=0&id=0a1ced72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ced72",
  null
  
)

export default component.exports